import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import styles from "../css/GadgetChannel.module.css";

interface GadgetChannelProps {
    header: string,
    channels: string[],
    icon: React.ReactNode,
    dataTestId: string
}

export const GadgetChannel = ({header, channels ,icon, dataTestId}: GadgetChannelProps) => {
  return (
    <Box>
      <div className={styles.channelHeaderContainer}>
        {icon}
        <Typography variant="h2" className={styles.channelHeaderText}>{header}</Typography>
      </div>
      <Box className={styles.channelContainer}>
      {
        channels.map((item) => <Chip label={item} className={styles.channelChip} data-testid={dataTestId} key={item}/>)
      }
      </Box>
    </Box>
  );
};